import * as ng from 'angular';
import * as _ from 'underscore';

import * as intlTelInput from 'intl-tel-input/build/js/intlTelInput.min.js';
import 'intl-tel-input/build/js/utils';

import { Country } from '../shared';
import countries from '../shared/countries';

ng.module('selfReg')
   .directive('phoneInput', phoneInputDirective);

export function phoneInputDirective() {
   return {
      require: '^ngModel',
      link: phoneInputLink,
      scope: {
         country: '<phoneInput'
      }
   };
}

function phoneInputLink(scope:ng.IScope, element, attrs, ctrl:ng.INgModelController) {
   const el = element[0];
   let iti = intlTelInput(el, {
      nationalMode: true,
      onlyCountries: _.map(countries, c => c.code.toLocaleLowerCase()),
      customPlaceholder: (placeholder:string) => placeholder.replace(/\d/g, 'X')
   });

   scope.$watch('country', onCountryChangeExternal);

   element.on('countrychange', onCountryChangeInternal);

   ctrl.$parsers.push(parseViewValue);
   ctrl.$viewChangeListeners.push(onValueChange);
   ctrl.$validators.phone = isValidPhone;

   function onValueChange() {
      iti.setNumber(ctrl.$viewValue);
   }

   function parseViewValue(value) {
      return iti.getNumber();
   }

   // country binding changed (i.e. not using phone input)
   function onCountryChangeExternal(country:Country) {
      // don't change country if field already has a value
      if (!ctrl.$viewValue && country) {
         iti.setCountry(country.code.toLowerCase());
      }
   }

   // user changed country in the phone input
   function onCountryChangeInternal() {
      if (ctrl.$viewValue) {
         ctrl.$setViewValue(iti.getNumber());
      }
   }

   function isValidPhone(modelValue) {
      return ctrl.$isEmpty(modelValue) || iti.isValidNumber();
   }
}
